import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Chippable } from '@app/interfaces';
import { JobPostingOptionalField } from '@app/modules/applicant-tracker/interfaces/optional-field.interface';
import { ApplicantOptionalFieldService } from '@app/modules/applicant-tracker/services';
import { BaseForm } from '@forms/base.form';
import { JobPosting } from '@models/recruiting/job-posting.model';
import { RequiredFieldsCardComponent } from '../../..';

@Component({
    selector: 'app-job-posting-store-helpers-information',
    templateUrl: './job-posting-store-helpers.form.html',
    styleUrls: ['./job-posting-store-helpers.style.scss'],
})
export class JobPostingStoreHelpersForm extends BaseForm implements OnInit {
    initialKeywords: Chippable[] = [];
    @Input() jobPosting: JobPosting;
    @ViewChild(RequiredFieldsCardComponent) private requiredFieldsCardComponent!: RequiredFieldsCardComponent;

    constructor(private applicantOptionalFieldService: ApplicantOptionalFieldService) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.initialKeywords = this.jobPosting.autoScoreKeywords.map((keyword) => ({
            chipLabel: keyword,
        }));
    }

    onChangeKeywords(autoScoreKeywords: Chippable[]): void {
        this.jobPosting.autoScoreKeywords = autoScoreKeywords.map((keyword) => keyword.chipLabel);
    }

    onSelectOptionalField(fields: JobPostingOptionalField[]): void {
        this.applicantOptionalFieldService.attachAndDetachToJobPosting(this.jobPosting, fields);
    }

    refreshRequiredFields(): void {
        this.requiredFieldsCardComponent.initialize();
    }
}
